import StandardPrintOption from './StandardPrintOption';

export default StandardPrintOption;
